import { render, staticRenderFns } from "./profession.vue?vue&type=template&id=46ea2ab9&"
import script from "./profession.vue?vue&type=script&lang=js&"
export * from "./profession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports